import { SUPPORTED_LANGUAGES } from "@is/i18n/supportedLanguages";

/**
 * The languages selectable under Language & country.
 *
 * These come from the app's own translation catalogs — see
 * `src/i18n/supportedLanguages.ts`. There is no request behind this hook, so the
 * picker cannot be affected by an unreachable backend; the `isLoading` / `error`
 * fields are kept so callers written against the previous fetching version keep
 * working unchanged.
 */
export const useLanguages = () => {
  return {
    languages: SUPPORTED_LANGUAGES,
    isLoading: false,
    error: undefined,
  };
};
